import $ from 'jquery'

import * as timecode from '../../../../lib/timecode'

import colors from '../../../../lib/colors'

import { button, input } from '../../../../component/component'

export function getTableDiv(value){

  var div =
    $('<div>')
    .text(value)
    .css({
      padding: '8px'
    })

  return div

}

export function filterMatch(column,filter){

  if(!column.value){
    if(filter === 'null'){
      return true
    } else {
      return false
    }
  }

  if (column.value && filter == '*'){
    return true
  }

  return true

}

export function getFormField(o,p,field){

  var format = function(value){
    return value
  }

  var parse = function(value){
    value = value.trim()
    return value
  }

  var validate = function(value){
    var reg = new RegExp(/(^(?:(?:[0-1][0-9]|[0-2][0-3]):)(?:[0-5][0-9]:){2}(?:[0-2][0-9])$)/)
    var valid = value.match(reg)
    if(
      valid ||
      (!value && field.optional)
    ){
      p.change(field,value,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      p.change(field,value,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var editing = false

  var toggle = function(){
    if(editing){
      stopBlinking()
      editing = false
    } else {
      startBlinking()
      editing = true
    }
  }

  var blinkInterval = null
  var blinkOn = false

  var startBlinking = function(){
    blinkOn = true
    editDiv.setColor(colors.red.s_500)
    blinkInterval =
      setInterval(function(){
        if(blinkOn){
          editDiv.setColor(colors.white)
          blinkOn = false
        } else {
          editDiv.setColor(colors.red.s_500)
          blinkOn = true
        }
      },300)
  }

  var stopBlinking = function(){
    blinkOn = false
    editDiv.setColor(colors.white)
    clearInterval(blinkInterval)
  }

  var update = function(){
    requestAnimationFrame(function(){
      if(editing){
        if(o.playing && o.looping){
          var v = timecode.toSmtp(o.loopStart)
          inputDiv.val(v)
          validate(v)
        } else if (!o.playing) {
          var v = timecode.toSmtp(o.video.currentTime)
          inputDiv.val(v)
          validate(v)
        }
      }
      update()
    })
  }
  update()

  var labelDiv =
    button(field.id,null,true)
    .css({
      display: 'block',
      paddingRight: '20px',
    })

  var editDiv =
    button(null,'fi-record',false,colors.white)
    .css({
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      borderTop: `1px solid ${colors.black}`,
      borderBottom: `1px solid ${colors.black}`,
    })
    .click(toggle)

  var inputDiv =
    input(true)
    .val(
      format(field.value)
    )
    .on('input',function(){
      var value = inputDiv.val()
      validate(parse(value))
    })

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      inputDiv,
    )

  if(field.edit){
    div.append(editDiv)
  }

  requestAnimationFrame(function(){
    var value = inputDiv.val()
    validate(parse(value))
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/timecode/timecode.js